module.exports = __webpack_public_path__ + "0.1.0/img/login-bg.4ff43167.png";